import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/esnext.string.at.js";
import * as msal from '@azure/msal-browser';
export default (function (_ref, inject) {
  var $app = _ref.$app,
    $config = _ref.$config,
    route = _ref.route;
  // Config object to be passed to Msal on creation

  var msalConfig = {
    auth: {
      tenant: $config.msal.tenant,
      // 'bd2e3d89-7c32-4ed7-a24f-09586d9d0e45',
      clientId: $config.msal.clientId,
      // 'da66211e-f871-4363-9afb-ad7ab48a6066',
      authority: $config.msal.authority,
      // 'https://login.microsoftonline.com/Notengoempresa290.onmicrosoft.com',
      redirectUri: '' // It has to be configured on your Azure tenant
    },
    cache: {
      cacheLocation: 'sessionStorage',
      // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  // Create the MSAL application object
  var myMSAL = new msal.PublicClientApplication(msalConfig);

  // Catch redirect callbacks
  myMSAL.handleRedirectPromise().then(handleResponse).catch(function (err) {
    console.error(err);
  });
  // Handle the response from AAD
  function handleResponse(resp) {
    if (resp !== null) {
      myMSAL.setActiveAccount(resp.account);
    }
  }

  // Add here scopes for id token to be used at MS Identity Platform endpoints.

  // Sign in the user
  function signIn() {
    return _signIn.apply(this, arguments);
  } // Get the account object of the signed-in user
  function _signIn() {
    _signIn = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var loginRequest;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            loginRequest = {
              scopes: [$config.msal.scope],
              redirectUri: window.location.href.split('?').at(0)
            };
            _context.next = 3;
            return myMSAL.loginPopup(loginRequest);
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _signIn.apply(this, arguments);
  }
  function getAccounts() {
    return myMSAL.getAllAccounts();
  }

  // Sign out the user
  function signOut(accountId) {
    var logoutRequest = {
      account: myMSAL.getAccountByHomeId(accountId)
    };
    return myMSAL.logoutRedirect(logoutRequest);
  }

  // Get acces token for calling API's
  function getToken() {
    var activeAccount = myMSAL.getAllAccounts()[0];
    var tokenRequest = {
      scopes: ['https://<yourtentant>.onmicrosoft.com/<yourapiexposed>/<yourapi.permission>'],
      account: activeAccount
    };
    return myMSAL.acquireTokenSilent(tokenRequest).then(function (accessTokenResponse) {
      var accessToken = accessTokenResponse.accessToken;
      return accessToken;
    }).catch(function (error) {
      // eslint-disable-next-line no-undef
      if (error instanceof InteractionRequiredAuthError) {
        myMSAL.acquireTokenPopup(tokenRequest).then(function (accessTokenResponse) {
          var accessToken = accessTokenResponse.accessToken;
          return accessToken;
        }).catch(function (error) {
          console.error(error);
        });
      } // catch any errors during the authentication process
    });
  }

  // inject functions on vue instance
  inject('msal', {
    signIn: signIn,
    getAccounts: getAccounts,
    signOut: signOut,
    getToken: getToken,
    myMSAL: myMSAL
  });
});